import { BACKEND_URL } from "../views/common/utils/constants";
import {
  IAPIResponse,
  ICountry,
  ICountryState,
} from "../views/common/utils/interfaces";
import { errorToastify } from "../views/common/utils/Toasty";
import { CustomAxios } from "./customAxios";

export const getTownsList = async (stateId: number) => {
  try {
    const { data: result }: IAPIResponse = await CustomAxios().get(
      `${BACKEND_URL}/locations/towns?state_id=${stateId}`
    );

    // const result = tempDummy;

    if (!result?.status) {
      throw new Error(result?.message);
    }
    return result;
  } catch (error) {
    if (typeof error === "string") {
      errorToastify(error);
    }
  }
};

export const getLGAsList = async (stateId: number) => {
  try {
    const { data: result }: IAPIResponse = await CustomAxios().get(
      `${BACKEND_URL}/locations/lgas?state_id=${stateId}`
    );

    // const result = tempDummy;

    if (!result?.status) {
      throw new Error(result?.message);
    }
    return result;
  } catch (error) {
    if (typeof error === "string") {
      errorToastify(error);
    }
  }
};

export const getStatesList = async (withListings = false) => {
  try {
    const { data: result }: IAPIResponse = await CustomAxios().get(
      `${BACKEND_URL}/locations/states${
        withListings ? "?include_number_of_listings" : ""
      }`
    );

    // const result = tempDummy;

    if (!result?.status) {
      throw new Error(result?.message);
    }
    return result;
  } catch (error) {
    if (typeof error === "string") {
      errorToastify(error);
    }
  }
};

export const getCountriesList = async () => {
  try {
    const { data: result }: IAPIResponse = await CustomAxios().get(
      `${BACKEND_URL}/locations/countries`
    );

    if (!result?.status) {
      throw new Error(result?.message);
    }
    return result?.data as ICountry[];
  } catch (error) {
    if (typeof error === "string") {
      errorToastify(error);
    }
  }
};

export const getCountryStatesList = async ({
  queryKey,
}: {
  queryKey: any[];
}) => {
  const countryId = queryKey[1]?.countryId;

  if (!countryId) {
    return [];
  }

  try {
    const { data: result }: IAPIResponse = await CustomAxios().get(
      `${BACKEND_URL}/locations/states/all?country=${countryId}`
    );

    if (!result?.status) {
      throw new Error(result?.message);
    }
    return result?.data as ICountryState[];
  } catch (error) {
    if (typeof error === "string") {
      errorToastify(error);
    }
  }
};
